import moment from "moment";
import React from "react";
import { SocialNetworkPosted, SourceType, UserGroups } from "../../../../interfaces";
import { AppUserContext } from "@/providers/AppContextProvider";
import { URLS } from "../../../../utils";

export const wrapInLinkIfHrefIsPresent = (href: string | undefined, children: React.ReactNode): React.ReactNode => {
  if (!href) return children;
  return (
    <a className="externalLink" href={href} onClick={e => e.stopPropagation()} target="_blank">
      {children}
    </a>
  );
};

export const formatDate = (date: string | null | undefined) => {
  return date ? moment(date).format("MM/DD/YYYY hh:mm a") : "";
};

export const getUrlForSource = (
  userContext: AppUserContext | undefined,
  sourceType: SourceType,
  sourceId: number
): string | undefined => {
  if (userContext === undefined) return undefined;
  const isPlayer = !!userContext.player;
  const isCoach = !!userContext.coach;
  const isAdmin = userContext.account.groups.some(g => g === UserGroups.ADMIN);

  switch (sourceType) {
    case "CAMPAIGN":
      if (isCoach) return URLS.coach.editCampaigns.replace(":campaignId", sourceId.toString());
      return undefined;
    case "VIDEO_PROJECT":
      if (isAdmin) return URLS.editor.editVideo.replace(":id", sourceId.toString());
      if (isPlayer) return URLS.player.videoProject.replace(":id", sourceId.toString());
      return URLS.coach.videoProject.replace(":id", sourceId.toString());
    case "PROMPT":
      return getUrlForPrompt(userContext, sourceId);
    case "CONTENT_PAGE":
      if (isPlayer) return URLS.player.videoPages;
      return undefined;
    case "POST":
    default:
      return undefined;
  }
};

export const getUrlForPlayer = (
  userContext: AppUserContext | undefined,
  playerId: string | number | undefined
): string | undefined => {
  if (!userContext || playerId === undefined) return undefined;
  if (!!userContext.coach) return URLS.coach.editPlayer.replace(":playerId", playerId.toString());
  return undefined;
};

export const getUrlForPrompt = (
  userContext: AppUserContext | undefined,
  promptId: string | number | undefined
): string | undefined => {
  if (!userContext || promptId === undefined) return undefined;
  if (!!userContext.coach) return URLS.coach.prompt.replace(":promptId", promptId.toString());
  if (!!userContext.player) return URLS.player.prompts;
  return undefined;
};

export const getUrlForSocialNetwork = (sn: SocialNetworkPosted): string | undefined => {
  if (sn.status !== "POSTED" || sn.externalPostUrl === undefined) return undefined;

  if (sn.socialNetworkId === "FB") {
    return sn.externalPostUrl;
  } else {
    return sn.externalPostUrl
      .replace("[", "")
      .replace("]", "")
      .split('"')
      .reduce((result, item) => {
        return `${result}${item}`;
      });
  }
};
